/**
 * holdemv2 FE 기본 공개 게임 타입 — `NEXT_PUBLIC_GAME_TYPE` env 미사용.
 * pathname(`/games_holdem`·`/games_seotda`)·`sessionStorage` 다음으로 폴백할 때만 사용.
 */
export const FE_DEFAULT_PUBLIC_GAME_TYPE: "SEOTDA" | "HOLDEM" = "HOLDEM";
